/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type { BettingLogger, BettingLoggerInterface } from "../BettingLogger";

const _abi = [
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tournamentId",
        type: "uint256",
      },
    ],
    name: "add",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tournamentId",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "addr",
        type: "address",
      },
    ],
    name: "adminAdd",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "all",
    outputs: [
      {
        internalType: "address[]",
        name: "ids",
        type: "address[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tournamentId",
        type: "uint256",
      },
    ],
    name: "allFor",
    outputs: [
      {
        internalType: "address[]",
        name: "ids",
        type: "address[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "length",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tournamentId",
        type: "uint256",
      },
    ],
    name: "lengthFor",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tournamentId",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "addr",
        type: "address",
      },
    ],
    name: "removeFor",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "addr",
        type: "address",
      },
    ],
    name: "removeFromAll",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "start",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "length",
        type: "uint256",
      },
    ],
    name: "slice",
    outputs: [
      {
        internalType: "address[]",
        name: "ids",
        type: "address[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tournamentId",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "start",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "length",
        type: "uint256",
      },
    ],
    name: "sliceFor",
    outputs: [
      {
        internalType: "address[]",
        name: "ids",
        type: "address[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "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";

export class BettingLogger__factory extends ContractFactory {
  constructor(signer?: Signer) {
    super(_abi, _bytecode, signer);
  }

  deploy(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<BettingLogger> {
    return super.deploy(overrides || {}) as Promise<BettingLogger>;
  }
  getDeployTransaction(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  attach(address: string): BettingLogger {
    return super.attach(address) as BettingLogger;
  }
  connect(signer: Signer): BettingLogger__factory {
    return super.connect(signer) as BettingLogger__factory;
  }
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): BettingLoggerInterface {
    return new utils.Interface(_abi) as BettingLoggerInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): BettingLogger {
    return new Contract(address, _abi, signerOrProvider) as BettingLogger;
  }
}
